import { formatPercentage } from "@/lib/access-report";

export interface BarListItem {
  label: string;
  value: number;
}

export function BarList({
  items,
  total,
  valueLabel = "listed",
}: {
  items: BarListItem[];
  total: number;
  valueLabel?: string;
}) {
  return (
    <div className="pb-access-bar-list">
      {items.map((item) => {
        const ratio = total > 0 ? item.value / total : 0;
        return (
          <div className="pb-access-bar-row" key={item.label}>
            <div className="pb-access-bar-row__label">
              <span>{item.label}</span>
              <span>
                <strong>{item.value}</strong> of {total} {valueLabel} · {formatPercentage(ratio)}
              </span>
            </div>
            <div
              className="pb-access-bar-track"
              role="img"
              aria-label={`${item.label}: ${item.value} of ${total}, ${formatPercentage(ratio)}`}
            >
              <span style={{ width: `${Math.min(100, Math.max(0, ratio * 100))}%` }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
